import { Button, HStack, Text, VStack } from "@chakra-ui/react"
import Link from "@pathwright/ux/src/components/link/Link"
import Pathicon from "@pathwright/ux/src/components/pathicon/Pathicon"
import { ReactNode } from "react"
import { PackageFragment, useAccountQuery } from "@pathwright/graphql-client/src/generated"
import PackageTag from "../../package/PackageTag"
import { usePathwrightContext } from "../../pathwright/PathwrightContext"

function SpaceActivationPrompt({ onClick }: { onClick: () => void }) {
  const { school } = usePathwrightContext()
  const accountQuery = useAccountQuery({
    // Any inactive school should see the activation prompt.
    skip: !school.is_activated
  })

  // Determine whether an active school school see the activation prompt.
  const { is_activated, is_on_legacy_plan, billing_subscription } = accountQuery
    .data?.account || {
    is_activated: false,
    is_on_legacy_plan: false,
    billing_subscription: null
  }
  const hasActivePathwrightSubscription = !!(
    is_activated &&
    (is_on_legacy_plan || billing_subscription)
  )

  return !accountQuery.loading && !hasActivePathwrightSubscription ? (
    <VStack w="100%" pt={4} gap={4}>
      <Button
        asChild
        colorPalette="brand"
        variant="solid"
        width="stretch"
        textDecoration="none"
        // We want to use a modified button style if this uses the package UI
        _hover={{
          textDecoration: "none"
        }}
      >
        <Link to="/pricing/" onClick={onClick}>
          <Pathicon icon="rocket" />
          Activate Now
        </Link>
      </Button>
      <PackageTag
        dataSource="assignment"
        renderWithTag={(tagRender: ReactNode, packageData: PackageFragment) =>
          packageData?.coupon_discount ? (
            <HStack p={0}>
              <Text fontSize="sm" m={0} color="gray.600">
                Get {packageData.coupon_discount}% off with{" "}
              </Text>
              {tagRender}
            </HStack>
          ) : null
        }
      />
    </VStack>
  ) : null
}

export default SpaceActivationPrompt
